/**
 * BOGO Manager - Performance Optimized Version
 * Extracted from sections/bogo-manager.liquid for better performance
 */

(function(){
  'use strict';
  
  // Wait for DOM to be ready
  function initBOGO() {
    try {
      // Get configuration from data attributes or window
      var configElement = document.querySelector('[data-bogo-config]');
      if (!configElement) {
        console.warn('[BOGO_MANAGER] Configuration element not found');
        return;
      }
      
      var config = JSON.parse(configElement.textContent || configElement.getAttribute('data-bogo-config') || '{}');
      if (!config.enabled) {
        console.log('[BOGO_MANAGER] Plugin disabled');
        return;
      }
      
      window.BOGO_CONFIG = config;
      
      if (config.debug) {
        console.log('[BOGO_CONFIG]', window.BOGO_CONFIG);
      }
      
      // Initialize sync button if endpoint exists
      initSyncButton(config);
      
      // Initialize copy button if enabled
      initCopyButton(config);
      
    } catch (err) {
      console.error('[BOGO_MANAGER] Initialization error', err);
    }
  }
  
  function initSyncButton(config) {
    if (!config.syncEndpoint) return;
    
    var btn = document.createElement('button');
    btn.textContent = '同步折扣码';
    btn.className = 'button';
    btn.style.marginTop = '8px';
    btn.setAttribute('type', 'button');
    
    var note = document.querySelector('.bogo-manager__note');
    if (note) {
      note.appendChild(btn);
    }
    
    btn.addEventListener('click', function(){
      btn.disabled = true;
      btn.textContent = '同步中...';
      
      fetch(config.syncEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          shop: config.shopDomain,
          config: window.BOGO_CONFIG 
        })
      })
      .then(function(response) { 
        return response.json(); 
      })
      .then(function(data){
        console.log('[BOGO_SYNC]', data);
        alert(data.ok ? '同步成功' : ('同步失败: ' + data.error));
        btn.disabled = false;
        btn.textContent = '同步折扣码';
      })
      .catch(function(error){ 
        console.error('[BOGO_SYNC] Error:', error);
        alert('同步失败: ' + error);
        btn.disabled = false;
        btn.textContent = '同步折扣码';
      });
    });
  }
  
  function initCopyButton(config) {
    if (!config.showCopy) return;
    
    var copyBtn = document.createElement('button');
    copyBtn.textContent = '复制规则 JSON';
    copyBtn.className = 'button';
    copyBtn.style.marginLeft = '8px';
    copyBtn.setAttribute('type', 'button');
    
    var note = document.querySelector('.bogo-manager__note');
    if (note) {
      note.appendChild(copyBtn);
    }
    
    copyBtn.addEventListener('click', function(){
      try {
        var text = JSON.stringify(window.BOGO_CONFIG, null, 2);
        
        // Modern clipboard API
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(text).then(function() { 
            showCopyFeedback(copyBtn, '已复制');
          }).catch(function() {
            fallbackCopy(text, copyBtn);
          });
        } else {
          fallbackCopy(text, copyBtn);
        }
      } catch(e) { 
        alert('复制失败');
      }
    });
  }
  
  function fallbackCopy(text, button) {
    // Fallback for older browsers
    var textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      document.execCommand('copy');
      showCopyFeedback(button, '已复制');
    } catch (err) {
      alert('复制失败');
    }
    
    document.body.removeChild(textArea);
  }
  
  function showCopyFeedback(button, message) {
    var originalText = button.textContent;
    button.textContent = message;
    button.disabled = true;
    
    setTimeout(function() {
      button.textContent = originalText;
      button.disabled = false;
    }, 2000);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBOGO);
  } else {
    initBOGO();
  }
})();